import parse from 'html-react-parser';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import type { ContentfulComponentEmbedCode } from 'graphqlTypes';

export type EmbedCodeProps = ContentfulComponentEmbedCode;

const EmbedCode = ({ embedCode, displayCode }: EmbedCodeProps) => {
  const innerCode = JSON.parse(embedCode?.raw);
  const codeString = innerCode.content.reduce(
    (accumulator: string, currentValue) => accumulator + currentValue.content[0]?.value,
    '',
  );

  useEffect(() => {
    if (codeString.includes('<script')) {
      const div = document.createElement('div');
      div.innerHTML = codeString;

      const scriptTag = div.querySelector('script');
      const script = document.createElement('script');
      script.type = scriptTag?.type || 'text/javascript';
      script.innerHTML = scriptTag.innerHTML;
      document.body.appendChild(script);
    }
  }, []);

  if (!embedCode) {
    return null;
  }

  if (displayCode === 'Head') {
    return <Helmet>{parse(codeString)}</Helmet>;
  }

  if (!codeString.includes('<script')) {
    return <div dangerouslySetInnerHTML={{ __html: codeString }}></div>;
  }

  return null;
};

export default EmbedCode;
